import {
  InjectionToken, Provider, Type,
} from '@angular/core'

export const HTML_PARSER_SERVICE_TOKEN = new InjectionToken<HtmlParserService>('HtmlParserService')

export function provideHtmlParserService(service: Type<HtmlParserService>): Provider {
  return {
    provide: HTML_PARSER_SERVICE_TOKEN,
    useClass: service,
  }
}

export interface HtmlParserService {

  textContent(html: string): string

  parseFromString(html: string): Document

}
